export const educatorProfileStepSX = {
    gridMain: {
        display: "flex",
        justifyContent: "flex-start",
        alignItems: "flex-start"
    },

    leftGrid: {
        p: { lg: 5, md: 5, sm: 5, xs: 2 },
        mb: 6,
        display: { lg: "flex" },
        flexDirection: "column",
        justifyContent: "flex-start",
        alignItems: "flex-start",
    },

    rightGrid: {
        p: { lg: 5, md: 5, sm: 5, xs: 2 },
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
    },

    aboutMeBox: {
        pt: 5,
        display: "flex",
        justifyContent: "space-between",
        width: "100%"
    },

    editButtonsWrapper: {
        display: { xs: "none", md: "flex" },
        gap: 2
    },

    cancelButton: {
        textAlign: "center",
        backgroundColor: "red",
        display: "flex",
        alignItems: "center",
        "&:hover": {
            backgroundColor: "red"
        }
    },

    saveButton: {
        textAlign: "center",
        backgroundColor: "green",
        "&:hover": {
            backgroundColor: "green"
        }
    },

    characterCountBox: {
        width: "100%",
        display: "flex",
        justifyContent: "space-between",
        flexDirection: { xs: "column", md: "row" }
    },

    errorTextBox: {
        color: "red",
        textAlign: "end",
        order: { xs: 2, md: 1 }
    },

    footerGridTitle: {
        display: { xs: "none", md: "flex" },
        justifyContent: "center",
        alignItems: "center",
        position: "absolute",
        left: "50%",
        top: "50%",
        transform: "translate(-50%, -50%)",
        flexDirection: { xs: "column", md: "row" },
        gap: 0.5,
        textAlign: "center",
        pointerEvents: "none"
    },

    errorBoxWrapper: {
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-end",
        mr: 3
    }
};
